import React, { Fragment } from 'react';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';

import HowItWorksSeekerPageService from './how-it-works-seeker.service.js';
import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import BulletList from '../../components/bullet-list/bullet-list.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './how-it-works-seeker.scss';

const Description = ({ data }) => (
	<section className="introduction">
		<div className="container container-fluid">
			<div className="row">
				<div className="col-xs-12 col-md-4 top-xs start-xs">
					{data.title && <h1 className="title">{data.title}</h1>}
				</div>
				<div
					className="col col-xs-12 col-md-8 col-lg-8 top-xs start-xs description"
					dangerouslySetInnerHTML={{ __html: data.description }}
				/>
			</div>
		</div>
	</section>
);

const JoinCard = ({ data }) => (
	<section className="join-card">
		<div className="container container-fluid">
			<div className="row">
				<div className="col-xs-12 middle-xs center-xs">
					<div className="card">
						<p>{data}</p>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://platform.inocrowd.com.pt/sign-up"
							className="btn-hover-effect"
						>
							<FormattedMessage id="howItWorks.seeker.button">
								{txt => <Fragment>{txt}</Fragment>}
							</FormattedMessage>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
);

class HowItWorksSeekerPage extends React.Component {
	static prefetchData = async language => HowItWorksSeekerPageService.getSeekerData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { seeker, setLoading } = this.props;

		ScrollToTop();

		if (!seeker) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		ScrollToTop();

		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const { language, setSeeker, setLoading } = this.props;

		setLoading(true);

		HowItWorksSeekerPage.prefetchData(language.value)
			.then((res) => {
				setSeeker(res);
				setLoading(false);
			})
			.catch(() => {
				this.setState({ hasError: true });
				setLoading(false);
			});
	}

	render() {
		const { seeker, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		const regex = /(<([^>]+)>)/ig;

		if (hasError || !seeker) {
			return <NotImplemented title="How it works - Seeker" />;
		}

		return (
			<div className="how-it-works-seeker-page">
				<Seo
					title={seeker.title || formatMessage({ id: 'navigation.howItWorks.seeker' })}
					description={seeker.description.replace(regex, '') || seeker.title || formatMessage({ id: 'navigation.howItWorks.seeker' })}
					image={seeker.image ? `${process.env.REACT_APP_API_ENDPOINT}${seeker.image.path}` : ''}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.howItWorks.seeker' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/how-it-works/seeker"
												}
											]
										}
									]
								}`}
				/>
				<Description data={seeker} />
				{seeker.image && (
					<div
						className="image"
						style={{
							backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT
								+ seeker.image.path}')`,
						}}
					/>
				)}
				<div className="section">
					<BulletList data={seeker} />
				</div>
				<div className="section">
					{seeker.platform_cta && <JoinCard data={seeker.platform_cta} />}
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, seeker, addresses, phones, generalData }) => ({
	language,
	seeker,
	addresses,
	phones,
	generalData,
});

export default injectIntl(
	connect(
		mapToProps,
		actions,
	)(HowItWorksSeekerPage),
);

export { HowItWorksSeekerPage };
